.wrapper {
  position: relative;
  width: 100%;
  border-radius: var(--radius-small);
  overflow: hidden;
  border: 1px solid var(--color-border);
  background: var(--color-card);
}

.aspectBox {
  position: relative;
  padding-top: 56.25%;
}

.iframe {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  border: none;
}

.preview {
  position: absolute;
  inset: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--color-text-muted);
  font-family: var(--font-body);
  transition: color var(--motion-fast) ease;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      color: var(--color-primary);
      .play {
        background: var(--color-primary);
        color: var(--color-cta-text-color);
      }
    }
  }

  /* Обычную рамку фокуса закрыла бы обложка, а снаружи обрезал бы overflow плеера —
     рисуем её слоем поверх обложки */
  &:focus-visible {
    outline: none;
  }

  &:focus-visible::after {
    content: "";
    position: absolute;
    inset: var(--space-3);
    outline: 2px solid var(--color-focus);
    pointer-events: none;
  }
}

.playContent {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-10);
  /* Не меньше 13px — минимум подписей по DESIGN.md; 10px заглавными не читались */
  font-size: var(--type-caption);
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.playIcon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--color-border);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text);
  transition:
    background var(--motion-fast) ease,
    color var(--motion-fast) ease;

  svg {
    width: 20px;
    height: 20px;
    /* Треугольник визуально центрируется со сдвигом вправо */
    margin-left: var(--space-2);
  }
}

.preview .poster {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.posterFrame {
  position: absolute;
  inset: 0;
}

/* Формат — от самого ролика, а не JPEG: у некоторых Shorts широкая обложка
   уже содержит резкие боковые вставки. Оставляем чётким только центральный кадр. */
.posterFrame[data-portrait="true"] {
  inset: auto;
  top: 0;
  left: 50%;
  height: 100%;
  aspect-ratio: var(--poster-aspect-ratio);
  overflow: hidden;
  transform: translateX(-50%);
}

.posterFrame[data-portrait="true"] .poster {
  inset: auto;
  top: 0;
  left: 50%;
  width: auto;
  max-width: none;
  height: 100%;
  transform: translateX(-50%);
}

.preview .posterBackdrop {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: blur(var(--space-16)) brightness(0.7);
  transform: scale(1.1);
}

.playButton {
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: clamp(var(--space-56), 6vw, var(--space-72));
  aspect-ratio: 1;
  border-radius: 50%;
  background: var(--color-primary);
  color: var(--color-cta-text-color);
  box-shadow: var(--shadow-overlay);
  transform: translate(-50%, -50%);
  transition: transform var(--motion-fast) var(--motion-ease-out-soft);

  svg {
    width: 40%;
    height: 40%;
    /* Треугольник визуально центрируется со сдвигом вправо */
    margin-left: 8%;
    fill: currentColor;
  }

  @media (hover: hover) and (pointer: fine) {
    .preview:hover & {
      transform: translate(-50%, -50%) scale(1.08);
    }
  }
}

.preview[data-static="true"] {
  cursor: default;
}
